<script setup>
import SidebarCard from '@/components/cards/SidebarCard.vue';
import AppFooter from '@/components/AppFooter.vue';
import NavTab from '@/components/navigation/NavTab.vue';
import SIdeBarPostList from '@/components/cards/SIdeBarPostList.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import AppHeader from '@/components/headers/AppHeader.vue';
import MainHeaderComponent from '@/components/headers/MainHeaderComponent.vue';
import ImageCard from '@/components/cards/ImageCard.vue';
import TopContributorComponent from '@/components/cards/TopContributorComponent.vue';
import { useBusinessStore } from '@/stores/business';
import {computed, onMounted, watch} from 'vue';
import { useContributorStore } from '@/stores/contributor';
import {useMiscStore} from "@/stores/misc";
import OverlayComponent from "@/components/OverlayComponent.vue";
import BestOfBestCard from "@/components/cards/BestOfBestCard.vue";
import CustomCardImageContent from "@/components/cards/CustomCardImageContent.vue";
import { useRoute, useRouter } from "vue-router";
import { ArrowRightIcon } from '@heroicons/vue/24/outline';

const store = useBusinessStore();
const misc = useMiscStore();
const route = useRoute();
const router = useRouter();
const contributorStore = useContributorStore();

const fetchData = (sortBy) => {
  store.fetchBusinesses(sortBy);
};

// Fetch initial data
onMounted(async () => {
  try {
    await Promise.all([
      store.fetchMostVoted(),
      store.fetchTopRated(),
      fetchData(route.query.sortBy),
      store.fetchBestOfVoted(),
      store.fetchBestOfRated(),
      contributorStore.fetchPopular('contributions')
    ]);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
});

watch(() => route.query.sortBy, (newSortBy) => {
  fetchData(newSortBy);
});

const businesses = computed(() => store.businesses || []),
 topRated = computed(() => store.topRated),
 bestOfRated = computed(() => store.bestOfRated),
 mostVoted = computed(() => store.mostVoted),
 bestOfVoted = computed(() => store.bestOfVoted),
 loading = computed(() => misc.loading),
 loadingTopRated = computed(() => store.loadingTopRated),
 loadingMostVoted = computed(() => store.loadingMostVoted),
 topContributors = computed(() => contributorStore.popular || contributorStore.topRated),
 loadingTopContributors = computed(() => contributorStore.loadingTopContributors);
console.log(topContributors.value);
</script>

<template>
  <DefaultLayout :loading="loading">
    <template #header>
      <AppHeader
        :height="'50vh'"
        :is-home-page="true"
      >
        <template #content>
          <MainHeaderComponent />
        </template>
      </AppHeader>
    </template>
    <template #main>
      <NavTab :businesses="businesses" />
    </template>
    <template #aside>
      <div class="relative">
        <ImageCard
          :image="{
            url: '/images/ind-day.jpg'
          }"
        />
        <OverlayComponent class="rounded-xl" />
      </div>
      <BestOfBestCard
        v-if="bestOfRated"
        :image="{
          url: bestOfRated?.baseImageUrl
        }"
      >
        <template #body>
          <CustomCardImageContent
            type="rated"
            :business="bestOfRated"
          />
        </template>
      </BestOfBestCard>
      <BestOfBestCard
        v-if="bestOfVoted"
        :image="{
          url: bestOfVoted?.baseImageUrl
        }"
      >
        <template #body>
          <CustomCardImageContent
            type="voted"
            :business="bestOfVoted"
          />
        </template>
      </BestOfBestCard>
      <SidebarCard
        :as-content="topRated.length > 0"
        :loading="loadingTopRated"
      >
        <template #header-title>
          Top Rated Businesses
        </template>
        <template #body>
          <SIdeBarPostList :businesses="topRated" />
        </template>
      </SidebarCard>

      <SidebarCard
        :as-content="mostVoted.length > 0"
        :loading="loadingMostVoted"
      >
        <template #header-title>
          Popular Businesses
        </template>
        <template #body>
          <SIdeBarPostList :businesses="mostVoted" />
        </template>
      </SidebarCard>

      <SidebarCard
        :as-content="topContributors?.items?.length > 0"
        :loading="loadingTopContributors"
      >
        <template #header-title>
          Top Contributors
        </template>
        <template #body>
          <TopContributorComponent :contributors="topContributors" />
        </template>
        <template #footer>
          <div
            onclick="return alert('Coming soon')"
            class="border-t border-gray-200 p-4 text-right text-red-600 hover:text-red-500 transition-all duration-700"
          >
            <router-link
              :to="`#`"
              class="text-xs font-semibold uppercase"
            >
              View all contributors
              <ArrowRightIcon class="inline h-4 w-4 ml-1" />
            </router-link>
          </div>
        </template>
      </SidebarCard>

      <SidebarCard>
        <template #header-title>
          How to Share
        </template>
        <template #body>
          <iframe
            loading="lazy"
            width="560"
            height="200"
            src="https://www.youtube.com/embed/EvhfN-fAy0I"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;"
            allowfullscreen
            class="w-full lazyload"
            title="Watch how to share"
          />
        </template>
      </SidebarCard>
    </template>
  </DefaultLayout>
  <AppFooter />
</template>

<style scoped></style>
